import React from 'react';
import PropTypes from 'prop-types';
import ReviewStepHeader from '../UI/ReviewStepHeader';
import { ShareTargetType } from '../data/ShareTargetType';
import ShareTargetCheckbox from './ShareTargetCheckbox';
import './shareEditor.css';

ShareEditor.propTypes = {
	shareTargetsEditor: PropTypes.object,
};

export default function ShareEditor({ shareTargetsEditor }) {
	const communities = shareTargetsEditor.getCommunities();
	const genreCommunitiesState = shareTargetsEditor.getGenreCommunityOptionsState();

	const renderGenreCommunityCheckBox = genreCommunity => {
		const shareTarget = {
			id: genreCommunity.id,
			type: ShareTargetType.genreCommunity,
		};
		return (
			<ShareTargetCheckbox
				key={genreCommunity.id}
				shareTarget={shareTarget}
				shareTargetsEditor={shareTargetsEditor}>
				{genreCommunity.name}
			</ShareTargetCheckbox>
		);
	};

	const renderCommunityCheckbox = community => {
		const shareTarget = {
			id: community.id,
			type: ShareTargetType.generalCommunity,
		};
		return (
			<ShareTargetCheckbox
				key={community.id}
				shareTarget={shareTarget}
				shareTargetsEditor={shareTargetsEditor}>
				{community.name}
			</ShareTargetCheckbox>
		);
	};

	return (
		<div className="share-editor editor-root">
			<ReviewStepHeader label="Share (3/3)" icon="usergroup-add" />
			<div className="checkbox-container">
				<ShareTargetCheckbox
					shareTarget={{ type: ShareTargetType.all }}
					shareTargetsEditor={shareTargetsEditor}>
					Select All
				</ShareTargetCheckbox>
				<ShareTargetCheckbox
					shareTarget={{ type: ShareTargetType.friends }}
					shareTargetsEditor={shareTargetsEditor}>
					Friends
				</ShareTargetCheckbox>
				<ShareTargetCheckbox
					shareTarget={{ type: ShareTargetType.colleagues }}
					shareTargetsEditor={shareTargetsEditor}>
					Colleagues
				</ShareTargetCheckbox>
				<ShareTargetCheckbox
					shareTarget={{ type: ShareTargetType.publisher }}
					shareTargetsEditor={shareTargetsEditor}>
					Publisher
				</ShareTargetCheckbox>
			</div>
			<h4>Genre Communities</h4>
			<div className="checkbox-container">
				{genreCommunitiesState.isLoading ? (
					<em>Loading options...</em>
				) : (
					genreCommunitiesState.options.map(
						renderGenreCommunityCheckBox,
					)
				)}
			</div>
			<h4>My Other Communities</h4>
			<div className="checkbox-container">
				{communities.map(renderCommunityCheckbox)}
			</div>
		</div>
	);
}
